



































import Component, { mixins } from "vue-class-component";
import { AxiosResponse } from "axios";
import ShowContainer from "@/common/mixin/ShowContainer";
import DetailRow from "@/common/component/DetailRow.vue";
import { configurationApi } from "@/context/configuration/api/ConfigurationApi";
import { ConfigurationShowModel } from "@/context/configuration/model/ConfiurationShowModel";
import { formatJson, notNullOrUndefined } from "@/utility/functions";
import CustomExpansionPanel from "@/general/component/expansion-panel/CustomExpansionPanel.vue";
import ProgressSpinnerWrapper from "@/common/component/ProgressSpinnerWrapper.vue";

@Component({
  components: { ProgressSpinnerWrapper, CustomExpansionPanel, DetailRow }
})
export default class ConfigurationShowContainer extends mixins(ShowContainer) {
  model!: ConfigurationShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await configurationApi.show(id);
    this.model = response?.data?.view;
    this.model.lastConfiguration = notNullOrUndefined(this.model.lastConfiguration)
      ? formatJson(this.model.lastConfiguration)
      : "";
    this.model.actualConfiguration = notNullOrUndefined(this.model.actualConfiguration)
      ? formatJson(this.model.actualConfiguration)
      : "";
    this.model.configurationToSend = notNullOrUndefined(this.model.configurationToSend)
      ? formatJson(this.model.configurationToSend)
      : "";
  }
}
